import { FC } from 'react';

import { getTheApp } from './TextBlock';
import { Image } from 'components/helpers';
import googleIcon from 'photos/googlePlay.png';
import appleIcon from 'photos/appleButton.png';

const GetTheAppButtons: FC = () => {
  return (
    <div className="get-the-app-buttons-container">
      <a href={getTheApp.links.google} className="get-the-app-button-container">
        <Image src={googleIcon} />
      </a>
      <a href={getTheApp.links.iphone} className="get-the-app-button-container">
        <Image src={appleIcon} />
      </a>
    </div>
  );
};

export default GetTheAppButtons;
